import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import Gallery from "../blocks/gallery";

const SingleAwardsNews = {
  init() {
    new Gallery(".gallery");
    SingleAwardsNews.articlesSlider();
    SingleAwardsNews.copyCurrentLink();
  },

  articlesSlider() {
    const articlesSwiperEl = $(".articles-slider");
    if (!articlesSwiperEl.length) {
      return;
    }

    if (articlesSwiperEl.length) {
      const navPrev = articlesSwiperEl.find(".swiper-button--prev");
      const navNext = articlesSwiperEl.find(".swiper-button--next");

      new Swiper(articlesSwiperEl.find(".swiper")[0], {
        modules: [Lazy, Navigation],
        slidesPerView: "auto",
        spaceBetween: 20,

        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
      });
    }
  },

  copyCurrentLink() {
    const buttons = document.querySelectorAll(".share__link-btn");
    buttons.forEach(btn => {
      btn.addEventListener("click", function () {
        const currentUrl = window.location.href;
        console.log("Sveiki");

        const toggleNotice = () => {
          this.querySelector(".notice").classList.toggle("hidden");
        };

        toggleNotice();
        setTimeout(toggleNotice, 3500);

        navigator.clipboard.writeText(currentUrl)
          .then(() => {
            console.log("Link copied to clipboard:", currentUrl);
          })
          .catch(err => {
            console.error("Failed to copy: ", err);
          });
      });
    });
  }
};

export default SingleAwardsNews;
